import styled from 'styled-components';
import { para1 } from '../../theme/GlobalStyle';

export const CustomPaginationContainer = styled.ul`
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;

  li a,
  li span {
    width: 42px;
    height: 42px;
    border: 1px solid ${(props) => props.theme.color.paginateBorder};
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.color.primary};
    ${para1}
    transition: color ease-in-out 0.2s, background-color ease-in-out 0.2s;
    cursor: pointer;
    svg {
      font-size: 22px;
      color: ${(props) => props.theme.color.primary};
    }
    &.active {
      color: ${(props) => props.theme.color.white};
      background-color: ${(props) => props.theme.color.primary};
      pointer-events: none;
    }
    &.disabled {
      pointer-events: none;
      svg {
        color: ${(props) => props.theme.color.paginationStroke};
        stroke: ${(props) => props.theme.color.paginationStroke};
      }
    }
    @media (min-width: 1024px) {
      &:hover {
        color: ${(props) => props.theme.color.white};
        background-color: ${(props) => props.theme.color.primary};

        svg {
          color: ${(props) => props.theme.color.white};
        }
      }
    }
  }
  &.for-mobile {
    display: none;
  }
  @media (max-width: 520px) {
    &.for-desktop {
      display: none;
    }
    &.for-mobile {
      display: flex;
    }
  }
`;
